import React from 'react';
import { Box, Typography } from '@mui/material';
import ManageMap from '../../ManageMap';

// Hosts the festival map editor inside the admin shell. ManageMap, when
// rendered with `embedded`, pushes its tool palette into the right sidebar
// via SidebarActionsContext, so this page only needs to render the grid.
const MapEditorPage = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
    <Typography variant="h5" sx={{ mb: 1 }}>
      Map Editor
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      Edit the festival booth grid. Click a cell to change its type. Drag across cells to batch edit.
    </Typography>
    <ManageMap embedded />
  </Box>
);

export default MapEditorPage;
